import { render, staticRenderFns } from "./CandidateJobItem.vue?vue&type=template&id=2f152dc6&scoped=true"
import script from "./CandidateJobItem.vue?vue&type=script&lang=js"
export * from "./CandidateJobItem.vue?vue&type=script&lang=js"
import style0 from "./CandidateJobItem.vue?vue&type=style&index=0&id=2f152dc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f152dc6",
  null
  
)

export default component.exports